"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteEditorToolbar = void 0;
var react_1 = __importDefault(require("react"));
var editor_web_1 = require("@21st-night/editor-web");
var slate_react_1 = require("slate-react");
var NoteEditorToolbar = function () {
    var isFocused = slate_react_1.useFocused();
    return (react_1.default.createElement("div", { style: {
            opacity: isFocused ? 1 : 0,
            userSelect: isFocused ? 'auto' : 'none',
            pointerEvents: isFocused ? 'auto' : 'none',
        } },
        react_1.default.createElement(editor_web_1.EditorToolbar, null)));
};
exports.NoteEditorToolbar = NoteEditorToolbar;
//# sourceMappingURL=NoteEditorToolbar.js.map